import React from "react";

import {Link} from "react-router-dom";
import {logAction} from "../../logging/logEvent";

const LoggingLink = ({to, loggingPayload, printConsoleLog = false, children, ...other}) => {
    function clicked() {
        logAction(loggingPayload, printConsoleLog);
    }

    return <Link {...other} onClick={clicked} to={to}>{children}</Link>;
};

export default LoggingLink;